import Commerce from '@chec/commerce.js'

const commerce = new Commerce('pk_513460d4dc92b017ef5b259e1e6d7bdf03c570335882b')

export default commerce;